import { createNamespacedHelpers } from 'vuex';

const typingActivity = createNamespacedHelpers('activity/typing');
const keyboard = createNamespacedHelpers('keyboard');
const student = createNamespacedHelpers('student');

export default {
  props: {
    name: {
      type: String,
      require: true
    },
    character: {
      type: String,
      default: ''
    },
    row: {
      type: String,
      required: true
    },
    alt: String,
    shift: {
      type: Boolean,
      default: false
    },
    special: String
  },

  computed: {
    // Vuex state
    ...student.mapState({ oneHandedTypingHand: state => state.oneHandedTypingHand }),
    ...typingActivity.mapState(['attemptedKey']),
    ...keyboard.mapState(['capsLock', 'holdKeyPressed']),
    ...keyboard.mapState({
      isGhosting: state => state.settings.isGhosting,
      keyboardShowing: state => state.show,
      showTargets: state => state.settings.showTargets,
      roofs: state => state.settings.roofs
    }),

    // Vuex getters
    ...keyboard.mapGetters(['activeLetters']),
    ...typingActivity.mapGetters(['targetKey', 'expectedKey', 'isTouchHold']),

    // Local computed properties
    baseClasses() {
      const multiCharacterKeys = ['backspace', 'caplock', 'enter', 'shift1', 'shift2', 'tab'];
      let activeKeys = this.activeLetters;

      // Remove all possible multi character keys if the current key is not one of them.
      if (!multiCharacterKeys.includes(this.character.toLowerCase())) {
        activeKeys = activeKeys.replaceAll(new RegExp(multiCharacterKeys.join('|'), 'gi'), '');
      }

      return {
        ghosting: this.isGhosting,
        active:
          activeKeys.toLowerCase().includes(this.character.toLowerCase()) ||
          (!this.oneHandedTypingHand && this.character === this.targetKey)
      };
    },

    isPressedKey() {
      const attemptedCharacter = this.attemptedKey.character;
      // An empty string indicates no current attempted key
      return attemptedCharacter && this.normalizedCharacter === attemptedCharacter;
    },

    keyStateClass() {
      if (this.isPressedKey) {
        return this.attemptedKey.isCorrect ? 'highlight' : 'error';
      }

      return '';
    },

    normalizedCharacter() {
      if (this.attemptedKey.withShift || this.capsLock) {
        return this.alt || this.character;
      }

      return this.showSpecial ? this.special : this.character;
    }
  }
};
